package fr.manyverse.app.presentation.components.onboarding

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Email
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import fr.manyverse.app.getPlatform
import fr.manyverse.app.presentation.layout.WindowWidth
import fr.manyverse.app.presentation.theme.Spacing
import fr.manyverse.app.presentation.viewmodel.AuthUiState
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.icon_apple
import manyverse.shared.generated.resources.icon_google
import manyverse.shared.generated.resources.icon_incognito
import manyverse.shared.generated.resources.sign_in_anonymous
import manyverse.shared.generated.resources.sign_in_with_apple
import manyverse.shared.generated.resources.sign_in_with_google
import manyverse.shared.generated.resources.sign_in_with_otp
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun OnboardingAuthButtons(
    uiState: AuthUiState,
    onShowEmailDialog: () -> Unit,
    onSignInWithGoogle: () -> Unit,
    onSignInWithApple: () -> Unit,
    onShowAnonymousWarningDialog: () -> Unit,
    windowWidth: WindowWidth,
    modifier: Modifier = Modifier
) {
    val buttonWidthFraction = if (windowWidth == WindowWidth.COMPACT) 0.9f else 1f
    val showAppleSignIn = getPlatform().isAppleSignInAvailable

    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(Spacing.small)
    ) {
        OutlinedButton(
            onClick = onShowEmailDialog,
            modifier = Modifier
                .fillMaxWidth(buttonWidthFraction)
                .testTag("onboardingEmailButton"),
            enabled = !uiState.isLoading
        ) {
            Icon(
                imageVector = Icons.Filled.Email,
                contentDescription = null,
                modifier = Modifier.size(18.dp)
            )
            Spacer(modifier = Modifier.width(8.dp))
            Text(stringResource(Res.string.sign_in_with_otp))
        }

        OutlinedButton(
            onClick = onSignInWithGoogle,
            modifier = Modifier
                .fillMaxWidth(buttonWidthFraction)
                .testTag("onboardingGoogleButton"),
            enabled = !uiState.isLoading
        ) {
            Icon(
                painter = painterResource(Res.drawable.icon_google),
                contentDescription = null,
                modifier = Modifier.size(18.dp),
                tint = Color.Unspecified
            )
            Spacer(modifier = Modifier.width(8.dp))
            Text(stringResource(Res.string.sign_in_with_google))
        }

        if (showAppleSignIn) {
            OutlinedButton(
                onClick = onSignInWithApple,
                modifier = Modifier
                    .fillMaxWidth(buttonWidthFraction)
                    .testTag("onboardingAppleButton"),
                enabled = !uiState.isLoading
            ) {
                Icon(
                    painter = painterResource(Res.drawable.icon_apple),
                    contentDescription = null,
                    modifier = Modifier.size(18.dp),
                    tint = MaterialTheme.colorScheme.onSurface
                )
                Spacer(modifier = Modifier.width(8.dp))
                Text(stringResource(Res.string.sign_in_with_apple))
            }
        }

        if (false) {
            OutlinedButton(
                onClick = onShowAnonymousWarningDialog,
                modifier = Modifier
                    .fillMaxWidth(buttonWidthFraction)
                    .testTag("onboardingAnonymousButton"),
                enabled = !uiState.isLoading
            ) {
                Icon(
                    painter = painterResource(Res.drawable.icon_incognito),
                    contentDescription = null,
                    modifier = Modifier.size(18.dp),
                    tint = MaterialTheme.colorScheme.onSurface
                )
                Spacer(modifier = Modifier.width(8.dp))
                Text(stringResource(Res.string.sign_in_anonymous))
            }
        }
    }
}